import React from 'react';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import TrashcanIcon from '@wix/da-ds/pkg/Icons/24x24/Trashcan';
import ActionBarIcon from '../../_partials/ActionBarIcon';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import ActionBarEditButton from '../../_partials/items/ActionBarEditButton';
import { useDeleteDeviationFlow } from '../../actionHooks/useDeleteDeviationFlow';

export interface Props {
  deviation: PapiDeviation;
  redirectTo?: string;
}

export const DeleteButton: React.FC<React.PropsWithChildren<Props>> = ({
  deviation,
  redirectTo,
}) => {
  const { t } = useTranslation();
  const { enactFlow, biData, supportingComponents } = useDeleteDeviationFlow(deviation, {
    redirectTo,
    supportTierDeletion: true,
  });

  return (
    <>
      <ActionBarItemWrapper tooltip={t('actionbar.delete')}>
        <ActionBarEditButton onClick={enactFlow} biData={biData}>
          <ActionBarIcon icon={TrashcanIcon} />
        </ActionBarEditButton>
      </ActionBarItemWrapper>
      {supportingComponents}
    </>
  );
};
DeleteButton.displayName = 'DeleteButton';

export default DeleteButton;
